/* eslint-disable jsx-a11y/click-events-have-key-events */
import { isEmpty, isFunction } from 'lodash';
import { connect } from 'react-redux';
import MediaQuery from 'react-responsive';
import PropTypes from 'prop-types';
import React from 'react';
import { PreviewPhoto } from '@sm360/widget-commons-basic-components';
import { ContentZonesService, LocaleService, WindowProxy } from '@sm360/widget-commons-core-services';
import {
    LightBox,
    MEDIA_QUERIES,
    ModalService,
    AnalyticsService,
    TRACKING_TAGS as TAGS,
    ShiftDigitalService,
    REDIRECTIONS,
    AdobeService,
    ADOBE_TAGS,
} from '@sm360/widget-commons-general';
import MessageHandler from '@sm360/widget-commons-forms';
import { Quote, Vehicle, VehicleConstants, ThirdPartiesJs } from '@sm360/widget-commons-vehicle';
import PaymentCalculator from '@sm360/widget-payment-calculator-v25';
import { withAnalyticsV25, SharingBar } from '@sm360/widget-commons-vdp';
import TradeIn360Default from '@sm360/widget-trade-in-360';

import URL from 'build-and-quote/constants/url.js';

import HeaderMessageV25 from 'build-and-quote/components/HeaderMessage/HeaderMessageV25.jsx';
import VehicleSpecsV25 from 'build-and-quote/components/Summary/components/VehicleSpecs/VehicleSpecsV25.jsx';
import VehicleCharacteristicsV25 from 'build-and-quote/components/Summary/components/VehicleCharacteristics/VehicleCharacteristicsV25.jsx';
import VehicleAccessories from 'build-and-quote/components/Summary/components/VehicleAccessories/VehicleAccessories.jsx';
import VehicleVideoRender from 'build-and-quote/components/Summary/components/VehicleVideo/VehicleVideoRender.jsx';
import DisclaimersV25 from 'build-and-quote/components/Summary/components/Disclaimers/DisclaimersV25.jsx';

import 'build-and-quote/components/Summary/summary.scss';

const { VehicleModelV25, VehicleBannerOverlay, ThirdPartiesCTA } = Vehicle;
const { motoInsight } = ThirdPartiesJs;
const { TradeInBarWrapper: TradeIn360BarWrapper, TradeInTiles: TradeIn360Tiles } = TradeIn360Default.components;

const MODAL = 'BuildAndQuote/VehicleVideo';
const modal = ModalService.get(MODAL);

class SummaryV25 extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            vehicle: this.props.vehicle,
            imageServer: this.props.imageServer,
            lightBoxIsOpen: false,
            lightBoxStartIndex: 0,
            vehicleIsStock: !!this.props.vehicle.vehicleId,
            wantHeader: false,
            hasSDInitialClickSent: false,
        };
        this.toggleLightBox = this.toggleLightBox.bind(this);
        this.showVideoModal = this.showVideoModal.bind(this);
        this.onPaymentCalculatorClose = this.onPaymentCalculatorClose.bind(this);
        this.saveToGarage = this.saveToGarage.bind(this);
        this.setSDInitialClickEvent = this.setSDInitialClickEvent.bind(this);
    }

    componentWillReceiveProps(newProps) {
        const { vehicle, websiteSoldDaysShown } = this.props;
        if (vehicle && vehicle.vehicleId && vehicle.vehicleId > 0) {
            // Verify if dateSold is beyond SoldDaysShown parameter, is so, redirect to listing
            if (
                (vehicle?.isSold() && vehicle.dateSold && !vehicle.isSoldShown(websiteSoldDaysShown)) ||
                vehicle.isDeleted()
            ) {
                const windowProxy = WindowProxy.get();
                const locale = LocaleService.getSimpleLocale();
                if (windowProxy) {
                    windowProxy.location.href = REDIRECTIONS[locale].listingNew;
                }
            }
        }

        if (this.props !== newProps) {
            this.setState({
                vehicle: newProps.vehicle,
                imageServer: newProps.imageServer,
                vehicleIsStock: !!newProps.vehicle.vehicleId,
            });
        }
    }

    componentDidUpdate() {
        if (window?.MOTOINSIGHT) {
            motoInsight(LocaleService.getLocale().toLowerCase());
        }
    }

    onPaymentCalculatorClose() {
        if (Quote.QuoteService.isQuoteInGarageV25(this.props.quote.id)) {
            this.props.saveToGarage();
        }
    }

    /*
    * Need to send drInitialClick events only once when user interact with DR tool
    * This will send event and set state so it will not send the event again
    */
    setSDInitialClickEvent() {
        ShiftDigitalService.updateDrInitialClick(this.props.quote.id, this.props.vehicle);
        this.setState({ hasSDInitialClickSent: true });
    }

    toggleLightBox() {
        AnalyticsService.gaTrigger(TAGS.ADDITIONNAL_PICTURES(WindowProxy.location().pathname));
        this.setState((prevState) => {
            return {
                lightBoxIsOpen: !prevState.lightBoxIsOpen,
                lightBoxStartIndex: 0,
            };
        });
    }

    showVideoModal() {
        modal.open();
    }

    saveToGarage(withAuthenthication) {
        this.setState({ wantHeader: true });
        if (isFunction(this.props.saveToGarage)) {
            this.props.saveToGarage(withAuthenthication, this.props.config);
        }
        if (!this.state.hasSDInitialClickSent) this.setSDInitialClickEvent();
    }

    render() {
        const locale = LocaleService.getSimpleLocale();
        const dealerUploadedImage = this.props.vehicle?.multimedia.getMainImage();
        const catalogImage = this.props.vehicle.multimedia?.getCatalogSideImage();

        const isComingSoon = this.props.vehicle.comingSoon;

        const isInTransit = this.props.vehicle.stickerStatusInTransit;

        const isOnOrder = this.props.vehicle.stickerStatusOnOrder;

        const isVehicleSold = this.props.vehicle.isSold();

        let vehicleStatusFilterContent;
        if (isComingSoon) vehicleStatusFilterContent = LocaleService.t('VEHICLE_STATUS.COMING_SOON');
        if (isInTransit) vehicleStatusFilterContent = LocaleService.t('VEHICLE_STATUS.IN_TRANSIT');
        if (isOnOrder) vehicleStatusFilterContent = LocaleService.t('VEHICLE_STATUS.ON_ORDER');
        if (isVehicleSold) vehicleStatusFilterContent = LocaleService.t('VEHICLE_STATUS.IS_SOLD');

        const isVehicleStatusFilter = (isComingSoon || isInTransit || isOnOrder || isVehicleSold) &&
            !this.props.vehicle.onHold && (
                <VehicleBannerOverlay icon="icon-stopwatch" content={vehicleStatusFilterContent} />
            );

        const background = `url(${ContentZonesService.getContentZone(
            'widget.build.and.buy',
            'hit.the.road.background.img'
        ).getValue()})`;
        const tradeInDescription = ContentZonesService.getContentZone(
            'widget.build.and.buy',
            'trade.in.description'
        ).getValue();
        const tradeInTitle = ContentZonesService.getContentZone('widget.build.and.buy', 'trade.in.title').getValue();
        const sectionTitle = ContentZonesService.getContentZone(
            'widget.build.and.buy',
            'trade.in.section.title'
        ).getValue();
        const buyOnlineCta = ContentZonesService.getContentZone(
            'widget.build.and.buy',
            'widget.build.and.buy.actions.cta.buy.online.text'
        );
        const getPriceCta = ContentZonesService.getContentZone(
            'widget.build.and.buy',
            'widget.build.and.buy.actions.cta.get.price.text'
        );
        const appointmentCta = ContentZonesService.getContentZone(
            'widget.build.and.buy',
            'widget.build.and.buy.actions.cta.appointment.text'
        );
        const extraCta = ContentZonesService.getContentZone(
            'widget.build.and.buy',
            'widget.build.and.buy.actions.cta.extra.cta'
        );
        // Get content zone value for Custom tag (Custom tag set from XMS)
        const getCZCustomTagContent = () => {
            return ContentZonesService.getContentZone('widget.build.and.buy', 'custom.tag.content')
                ? ContentZonesService.getContentZone('widget.build.and.buy', 'custom.tag.content').getValue()
                : '';
        };

        const roadsterCZCtaLabel = ContentZonesService.getContentZone('widget.build.and.buy', 'roadster.cta.label')
            ? ContentZonesService.getContentZone('widget.build.and.buy', 'roadster.cta.label').getValue()
            : LocaleService.t('CALL_TO_ACTION.BTN_ROADSTER_TEXT');

        const shopClickDriveCZCtaLabel = ContentZonesService.getContentZone(
            'widget.build.and.buy',
            'shop.click.drive.cta.label'
        )
            ? ContentZonesService.getContentZone('widget.build.and.buy', 'shop.click.drive.cta.label').getValue()
            : LocaleService.t('CALL_TO_ACTION.BTN_SHOP_CLICK_DRIVE_TEXT');

        // Display new inventory catalog image or dealer uploaded image
        const displayCatalogImage = ContentZonesService.getContentZone('widget.build.and.buy', 'show.catalog.img');

        // Promo banner for tablet and bigger screen size
        const displayPromoBanner = ContentZonesService.getContentZone('widget.build.and.buy', 'promo.banner.big.img');

        // Promo banner for mobile and small screen size
        const displayPromoBannerMobile = ContentZonesService.getContentZone(
            'widget.build.and.buy',
            'promo.banner.mobile.img'
        );

        // Display Sharing bar on Build and quote
        const displaySharingBar = ContentZonesService.getContentZone('widget.build.and.buy', 'show.sharing.bar');

        const summaryClass = ['section-summary', 'section-background', 'has-secondary-background'];

        const vehicleTitleMake = this.state.vehicle.isModelContainsMake() ? '' : this.state.vehicle.getSpecificMake();

        const vehicleTitle = LocaleService.t('summarySection.TITLE', {
            year: this.state.vehicle.year,
            make: vehicleTitleMake,
            model: this.state.vehicle.getModel(),
            modelTrim: this.state.vehicle.modelTrim.name,
        });

        const stockNo = this.props.vehicle.stockNumber;

        const vinNo = this.props.vehicle.vin;

        const calculator = (
            <PaymentCalculator.PaymentCalculator
                onClose={this.onPaymentCalculatorClose}
                hasCustomButton
                hasSDInitialClickSent={this.state.hasSDInitialClickSent}
                onSetSDInitialClickEvent={this.setSDInitialClickEvent}
                config={this.props.config}
                hasAdobeTagging={this.props.hasAdobeTagging}
                vehicle={this.props.vehicle}
                displayCreditRate={this.props.displayCreditRate}
            />
        );

        // TODO FIX nested-ternary
        /* eslint-disable no-nested-ternary */
        let handlerMessage =
            !this.props.quote.modified && Quote.QuoteService.isQuoteInGarageV25(this.props.quote.id)
                ? LocaleService.t('summarySection.BUILD_SAVED')
                : this.state.vehicleIsStock
                    ? LocaleService.t('summarySection.BUILD_VALIDATION_STOCK')
                    : LocaleService.t('summarySection.BUILD_VALIDATION_DEFAULT');

        if (this.props.quote.error) handlerMessage = this.props.quote.error;
        /* eslint-enable no-nested-ternary */
        const quoteNotSaved =
            this.props.quote.modified ||
            this.props.quote.error ||
            !Quote.QuoteService.isQuoteInGarageV25(this.props.quote.id);
        let handlerCode = quoteNotSaved ? 'warning' : 'success';
        if (this.props.quote.error) handlerCode = 'error';

        const carMissingImages = (
            <div className="car__missing-photo">
                <p className="car__missing-photo-label sr-text is-bold">
                    {LocaleService.t('MISSING_PHOTO.NOT_AVAILABLE')}
                </p>
                <img
                    alt={vehicleTitle}
                    className="car-image-front"
                    src={`${this.state.imageServer.imageServerDomain}/ir/w960h450c${URL.NO_PHOTO}`}
                />
            </div>
        );

        let carImages;
        if (
            displayCatalogImage &&
            displayCatalogImage.getValue() === 'false' &&
            this.props.quote.isQuoteVehicleFromInventory() &&
            dealerUploadedImage
        ) {
            carImages = <img alt={vehicleTitle} className="car-image-front" src={dealerUploadedImage} />;
        } else {
            carImages = catalogImage ? (
                <img alt={vehicleTitle} className="car-image-front" src={catalogImage} />
            ) : (
                carMissingImages
            );
        }

        const tradeInTileContent = (
            <TradeIn360BarWrapper
                isShowroomV2Enabled={this.props?.isShowroomV2Enabled}
                style={{ width: '100%' }}
                quote={this.props?.quote}
                organizationUnitId={this.props?.config?.orgUnitId}
                websiteLogo={this.props?.config?.websiteLogo}
                websiteDomain={this.props?.config?.websiteDomain}
                organizationUnitPhone={this.props?.config?.orgUnitPhone}
                websiteFacebookPageUrl={this.props?.config?.websiteFacebookPageUrl}
                websiteInstagramClientId={this.props?.config?.websiteInstagramClientId}
                websiteInstagramUserId={this.props?.config?.websiteInstagramUserId}
                websiteTwitterUrl={this.props?.config?.websiteTwitterUrl}
                websiteYoutubeUrl={this.props?.config?.websiteYoutubeUrl}
                organizationUnitName={this.props?.config?.orgUnitName}
                dealerMake={this.props?.config?.dealerMake}
                isBarWrapper
            />
        );

        const trackPriceQuoteCTAV25 = () => {
            if (this.props.hasAdobeTagging) {
                AdobeService.eventTrigger(
                    ADOBE_TAGS.REQUIRE_INFO_CTA(
                        this.props.quote?.vehicle?.vehicleCondition,
                        {
                            make: this.props.quote?.vehicle?.make?.name,
                            model: this.props.quote?.vehicle?.model?.name,
                            bodyStyle: this.props.quote?.vehicle?.bodyStyle?.name,
                        },
                        this.props.vehicle?.commercialVehicle
                    ),
                    'form-submit'
                );
            }
            AnalyticsService.ga4Trigger(
                TAGS.REQUEST_INFO_CTA(this.props.quote.vehicle.getModel(), this.props.quote.vehicle.year)
            );
        };

        const trackBuyOnlineCta = () => {
            AnalyticsService.gaTrigger(TAGS.RESERVE_IT_NOW_CTA_NEW(this.props.vehicle?.getModel()));
            if (!this.state.hasSDInitialClickSent) this.setSDInitialClickEvent();
        };

        const trackBuyOnlineCtaOnEndProcessGaTag = TAGS.RESERVE_IT_NOW_PROCESS_ENDED_NEW(
            this.props.vehicle?.getModel()
        );

        const trackAppointmentCta = () => {
            AnalyticsService.gaTrigger(TAGS.PREPARE_YOUR_VISIT_CTA_NEW(this.state.vehicle?.getModel()));
            if (!this.state.hasSDInitialClickSent) this.setSDInitialClickEvent();
        };

        const appointmentCtaOnEndProcessGaTag = TAGS.PREPARE_YOUR_VISIT_PROCESS_ENDED_NEW(
            this.state.vehicle?.getModel()
        );

        const { vehicle } = this.state;
        const demoTag = vehicle.vehicleCondition &&
            displayCatalogImage &&
            displayCatalogImage.getValue() !== 'false' &&
            vehicle.vehicleCondition === VehicleConstants.VEHICLE_CONDITION.DEMO && (
                <div className="demo-tag">{LocaleService.t('VEHICLE_STATUS.DEMO_TAG')}</div>
            );

        const contentZoneLegalDisclaimer = ContentZonesService.getContentZone(
            'widget.build.and.buy',
            'widget.build.and.buy.legal.disclaimer'
        );

        const legalDisclaimerCz = contentZoneLegalDisclaimer ? contentZoneLegalDisclaimer.getValue() : '';

        const displayCompare = ContentZonesService.getContentZone(
            'widget.build.and.buy',
            'widget.build.and.buy.show.compare'
        );
        // Div which will display car images
        const carImagesBlock = (
            <div className="car-images">
                <div className="car-images-share-and-compare">
                    {displaySharingBar && displaySharingBar.getValue() === 'true' && <SharingBar />}
                    {displayCompare &&
                        displayCompare.getValue() === 'true' && (
                            <Vehicle.CompareButton categoryName="new" vehicleId={vehicle.vehicleId} />
                        )}
                </div>
                {demoTag}
                {isVehicleStatusFilter}
                {carImages}
                <div className="car-multimedias">
                    {vehicle.multimedia.hasVideo(locale) && (
                        <button onClick={this.showVideoModal} className="video-cta">
                            <icon className="icon-play-button is-util" />
                            {LocaleService.t('summarySection.SEE_VIDEO')}
                        </button>
                    )}
                    {vehicle.multimedia.hasPictures() && (
                        <div role="button" tabIndex={0} onClick={this.toggleLightBox}>
                            <PreviewPhoto
                                imageUrl={vehicle.multimedia.getMainImage360x270()}
                                noPhotoUrl={URL.NO_PHOTO}
                                pictures={vehicle.multimedia.pictures}
                                yearMakeModel={vehicle.getYearMakeModel()}
                            />
                        </div>
                    )}
                </div>
            </div>
        );

        const optionsAndAccessories = vehicle.getOptionsAndAccessories();

        const {
            motoInsightNewEnabled,
            roadsterNewEnabled,
            eshopNewEnabled,
            shopClickDriveNewEnabled,
            roadsterLink,
            dealerCode,
            dealerBAC,
        } = this.props;

        return (
            <section className={summaryClass.join(' ')} style={{ backgroundImage: background }}>
                {!vehicle.onHold &&
                    !this.props.vehicle.isSold() &&
                    !isEmpty(this.props.purchaseMethods) &&
                    (this.state.wantHeader || quoteNotSaved) && (
                        <MessageHandler.MessageHandler
                            body={
                                <HeaderMessageV25
                                    message={handlerMessage}
                                    saveToGarage={this.saveToGarage}
                                    hasAdobeTagging={this.props.hasAdobeTagging}
                                    vehicle={this.props.vehicle}
                                />
                            }
                            classes={['HeaderMessage']}
                            code={handlerCode}
                            canCloseElement={false}
                        />
                    )}
                <div className="bloc-container">
                    <div className="bloc-container-wrapper">
                        <div className="section-summary__content">
                            <div className="section-summary__content-header">
                                <MediaQuery maxWidth={MEDIA_QUERIES.TABLET.MAX}>{carImagesBlock}</MediaQuery>
                                {!isEmpty(this.props.purchaseMethods) && (
                                    <div className="section-summary__content-title">
                                        <Vehicle.VehicleSummary
                                            isReserved={vehicle.onHold}
                                            isCustomTag={vehicle?.custom}
                                            customTagContent={getCZCustomTagContent()}
                                            title={vehicleTitle}
                                            vehicleStockNo={stockNo}
                                            vehicleVinNo={vinNo}
                                            // purchaseMethods={selectedConfiguration.purchaseMethods}
                                            taxCodes={this.props.purchaseMethods.getTaxCodesString()}
                                            taxesDisclaimer={this.props.purchaseMethods.getTaxesDisclaimer()}
                                            optionalDemoTag={
                                                displayCatalogImage &&
                                                displayCatalogImage.getValue() === 'false' &&
                                                vehicle.vehicleCondition &&
                                                vehicle.vehicleCondition === VehicleConstants.VEHICLE_CONDITION.DEMO
                                            }
                                            purchaseMethods={this.props.purchaseMethods}
                                            packageName={vehicle.getPackageName()}
                                            tagline={vehicle?.tagline}
                                            config={this.props.config}
                                            displayCreditRate={this.props.displayCreditRate}
                                            isPageTitle
                                        />
                                        <div className="section-summary__content-calculator">{calculator}</div>
                                        {!this.props.vehicle.onHold &&
                                            !this.props.vehicle.isSold() && (
                                                <>
                                                    <div>
                                                        <Vehicle.PriceQuoteCTAV25
                                                            vehicle={vehicle}
                                                            buttonClass="sr-button-1 is-fluid"
                                                            alternativeLabel={getPriceCta && getPriceCta.getValue()}
                                                            onClick={trackPriceQuoteCTAV25}
                                                        />
                                                        <MediaQuery maxWidth={MEDIA_QUERIES.MOBILE.MAX}>
                                                            <Vehicle.BuyOnlineCTAV25
                                                                quote={this.props.quote}
                                                                alternativeLabel={
                                                                    buyOnlineCta && buyOnlineCta.getValue()
                                                                }
                                                                onClick={trackBuyOnlineCta}
                                                                onEndProcessGaTag={trackBuyOnlineCtaOnEndProcessGaTag}
                                                            />
                                                        </MediaQuery>
                                                        <Vehicle.AppointmentCTAV25
                                                            quote={this.props.quote}
                                                            alternativeLabel={
                                                                appointmentCta && appointmentCta.getValue()
                                                            }
                                                            buttonClass="sr-button-2 is-fluid"
                                                            onClick={trackAppointmentCta}
                                                            onEndProcessGaTag={appointmentCtaOnEndProcessGaTag}
                                                            hasAdobeTagging={this.props.hasAdobeTagging}
                                                            vehicle={this.props.vehicle}
                                                        />
                                                    </div>

                                                    <ThirdPartiesCTA
                                                        motoInsightEnabled={motoInsightNewEnabled}
                                                        roadsterEnabled={roadsterNewEnabled}
                                                        shopClickDriveEnabled={shopClickDriveNewEnabled}
                                                        eshopEnabled={eshopNewEnabled}
                                                        roadsterLink={roadsterLink}
                                                        dealerBAC={dealerBAC}
                                                        dealerCode={dealerCode}
                                                        vehicle={vehicle}
                                                        eshopExtraClass="fullWidth"
                                                        roadsterCZCtaLabel={roadsterCZCtaLabel}
                                                        shopClickDriveCZCtaLabel={shopClickDriveCZCtaLabel}
                                                    />

                                                    <Vehicle.ExtraCTAV25
                                                        ctaLabel={extraCta && extraCta.getValue()}
                                                        ctaLink={extraCta.getLink()}
                                                        buttonClass="sr-button-2 is-fluid"
                                                        quote={this.props.quote}
                                                    />
                                                </>
                                            )}
                                    </div>
                                )}
                                <MediaQuery minWidth={MEDIA_QUERIES.LAPTOP.MIN}>{carImagesBlock}</MediaQuery>
                            </div>
                            <MediaQuery minWidth={MEDIA_QUERIES.TABLET.MIN}>
                                {displayPromoBanner &&
                                    displayPromoBanner.getValue() && (
                                        <div className="promo-banner">
                                            <img
                                                alt={displayPromoBanner.getValue()}
                                                src={displayPromoBanner.getValue()}
                                            />
                                        </div>
                                    )}
                            </MediaQuery>
                            <MediaQuery maxWidth={MEDIA_QUERIES.MOBILE.MAX}>
                                {displayPromoBannerMobile &&
                                    displayPromoBannerMobile.getValue() && (
                                        <div className="promo-banner">
                                            <img
                                                alt={displayPromoBannerMobile.getValue()}
                                                src={displayPromoBannerMobile.getValue()}
                                            />
                                        </div>
                                    )}
                            </MediaQuery>
                            <div className="car-equipments_summary">
                                <VehicleSpecsV25
                                    selectedDriveTrain={vehicle.getDriveTrain()}
                                    selectedEngine={vehicle.getEngine()}
                                    selectedTransmission={vehicle.transmission}
                                    CityFuelConsumption={vehicle.getConsumptionInCity()}
                                    HighwayFuelConsumption={vehicle.getConsumptionOnHighway()}
                                    selectedOptionsPackageExteriorColor={vehicle.exteriorColor}
                                    selectedOptionsPackageInteriorColor={vehicle.interiorColor}
                                    vehicleCondition={vehicle.vehicleCondition}
                                    odometer={vehicle.odometer}
                                />
                                {vehicle.getModel() && (
                                    <VehicleCharacteristicsV25
                                        selectedPackage={vehicle.getPackageName()}
                                        trim={vehicle.getTrim()}
                                        configuration={vehicle.configuration}
                                        isDoubleColumnLayout={!optionsAndAccessories.length}
                                        selectedModel={vehicle.getModel()}
                                        options={vehicle?.options}
                                    />
                                )}

                                {!isEmpty(optionsAndAccessories) && (
                                    <VehicleAccessories
                                        selectedAccessories={optionsAndAccessories}
                                        selectedModel={vehicle.getModel()}
                                        hasAvailableAccessories={!!optionsAndAccessories?.length}
                                        isVehicleFromInventory={!!vehicle.vehicleId}
                                    />
                                )}
                            </div>
                            {!isEmpty(this.props.purchaseMethods) && (
                                <div>
                                    <MediaQuery minWidth={MEDIA_QUERIES.TABLET.MIN} className="vdp-wrapper-warranties">
                                        <Vehicle.Overview
                                            title={vehicleTitle}
                                            taxCodes={this.props.purchaseMethods.getTaxCodesString()}
                                            taxesDisclaimer={this.props.purchaseMethods.getTaxesDisclaimer()}
                                            optionalButton={calculator}
                                            imageUrl={vehicle.multimedia.getCatalogSideImage360x197()}
                                            isReserved={vehicle.onHold}
                                            isSold={this.props.vehicle.isSold()}
                                            sectionTitle={sectionTitle}
                                            quote={this.props.quote}
                                            optionalBuyCta={buyOnlineCta && buyOnlineCta.getValue()}
                                            optionalAppointmentCta={appointmentCta && appointmentCta.getValue()}
                                            hasSDInitialClickSent={this.state.hasSDInitialClickSent}
                                            onSetSDInitialClickEvent={this.setSDInitialClickEvent}
                                            purchaseMethodsV25={this.props.purchaseMethods}
                                            config={this.props.config}
                                            hasAdobeTagging={this.props.hasAdobeTagging}
                                            vehicle={this.props.vehicle}
                                            displayCreditRate={this.props.displayCreditRate}
                                        />
                                        <DisclaimersV25
                                            legalDisclaimerCz={legalDisclaimerCz}
                                            vehicleDisclaimer={this.props.purchaseMethods?.disclaimer}
                                        />
                                        <TradeIn360Tiles
                                            descriptions={tradeInDescription}
                                            title={tradeInTitle}
                                            quote={this.props.quote}
                                            tradeInTileContent={tradeInTileContent}
                                            isShowroomV2Enabled={this.props.isShowroomV2Enabled}
                                        />
                                    </MediaQuery>
                                    <MediaQuery maxWidth={MEDIA_QUERIES.MOBILE.MAX}>
                                        <TradeIn360Tiles
                                            descriptions={tradeInDescription}
                                            title={tradeInTitle}
                                            quote={this.props.quote}
                                            tradeInTileContent={tradeInTileContent}
                                            isShowroomV2Enabled={this.props.isShowroomV2Enabled}
                                        />
                                        <DisclaimersV25
                                            legalDisclaimerCz={legalDisclaimerCz}
                                            vehicleDisclaimer={this.props.purchaseMethods?.disclaimer}
                                        />
                                    </MediaQuery>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
                <VehicleVideoRender videoURL={this.props.vehicle.multimedia.getVideo(locale)} />
                {this.state.lightBoxIsOpen && (
                    <LightBox
                        pictures={this.props.vehicle.multimedia.pictures}
                        toggleLightBox={this.toggleLightBox}
                        imageIndex={this.state.lightBoxStartIndex}
                    />
                )}
            </section>
        );
    }
}

SummaryV25.defaultProps = {
    taxCodes: [],
    websiteSoldDaysShown: 0,
    config: {},
    hasAdobeTagging: false,
    displayCreditRate: false,
    motoInsightNewEnabled: false,
    roadsterNewEnabled: false,
    eshopNewEnabled: false,
    shopClickDriveNewEnabled: false,
    roadsterLink: '',
    dealerCode: '',
    dealerBAC: '',
};

SummaryV25.propTypes = {
    imageServer: PropTypes.shape({
        imageServerDomain: PropTypes.string.isRequired,
        imageServerFullSize: PropTypes.string.isRequired,
    }).isRequired,
    quote: PropTypes.instanceOf(Quote.QuoteModelV25).isRequired,
    saveToGarage: PropTypes.func.isRequired,
    // eslint-disable-next-line react/require-default-props
    isShowroomV2Enabled: PropTypes.bool,
    vehicle: PropTypes.instanceOf(VehicleModelV25).isRequired,
    // websiteSoldDaysShown: PropTypes.number,
    config: PropTypes.object,
    hasAdobeTagging: PropTypes.bool,
    displayCreditRate: PropTypes.bool,
    motoInsightNewEnabled: PropTypes.bool,
    roadsterNewEnabled: PropTypes.bool,
    eshopNewEnabled: PropTypes.bool,
    shopClickDriveNewEnabled: PropTypes.bool,
    roadsterLink: PropTypes.string,
    dealerCode: PropTypes.string,
    dealerBAC: PropTypes.string,
};

SummaryV25.displayName = 'SummaryV25';

function mapStateToProps(state) {
    return {
        purchaseMethods: state.purchaseMethodsV25,
        quote: state.quoteV25,
        garageQuotes: state.quotes,
    };
}

export default connect(
    mapStateToProps,
    null
)(withAnalyticsV25(SummaryV25));

export { SummaryV25 };
